import * as React from 'react';
import ComponentUpdateFeed from './componentUpdateFeed.js';
import ComponentUpdateFeedItem from './componentUpdateFeedItem.js';

/**
 * @typedef {import('../../App.d.ts').ExternalUpdateFeedProps} ExternalUpdateFeedProps
 */
/**
 *
 * @param {ExternalUpdateFeedProps} props
 * @returns {Element}
 */
export default (props) => (
  <ComponentUpdateFeed
    data-testid="update-feed"
    {...props}
  >
    {props.items.map((item) => (
      <ComponentUpdateFeedItem
        data-testid="update-feed-item"
        {...item}
        key={item.title}
      />
    ))}
  </ComponentUpdateFeed>
);
